<template>
  <tr>
    <td class="col-md-1">
      {{ indexLine + 1 }}
    </td>
    <td class="col-md-4">
      <validation-provider
        v-slot="v"
        :name="`${productId}name`"
        rules="required"
      >
        <input
          type="text"
          class="form-control-lg width-max-name"
          :class="{
            'is-invalid': v.errors.length,
          }"
          :readonly="true"
          style="font-size: 16px"
          :value="
            lang === 'pl' ? line.product.name : line.product.descriptionEn
          "
        />
      </validation-provider>
      <br />
      {{ $t("products.itemCode") }}: {{ line.product.sku }}
    </td>
    <td class="col-md-1 text-left width-mid">
      <!--      {{ currencyDisplay(line.basePrice) }}-->
      <!--      <br>-->
      <!--      <br>-->
      <div class="showCustomPriceEdit visible">
        <div class="input-group" style="width:10em">
          <div class="input-group-prepend invisible" style="display: none">
            <div class="input-group-text">
              <input
                id="checkbox"
                :readonly="true"
                :checked="!enableCustomPrice"
                type="checkbox"
                @change="enableCustomPrice = !enableCustomPrice"
              />
            </div>
          </div>
          <validation-provider
            v-slot="v"
            :name="`${productId}price`"
            rules="required|between:0,100000"
            slim
          >
            <input
              class="form-control"
              :disabled="!enableCustomPrice"
              :class="{
                'is-invalid': v.errors.length,
              }"
              :value="priceInputValue"
              @input="sendChangePrice"
            />
          </validation-provider>
        </div>
      </div>
      <br />
    </td>
    <td colspan="2" class="col-md-1">
      <!-- :rules="getLineLimitQuantity(line)" -->
      <div class="input-group">
        <validation-provider v-slot="v" :name="`${productId}quantity`" slim>
          <input
            type="text"
            class="form-control width-mid"
            :class="{
              'is-invalid': v.errors.length,
            }"
            :value="quantityInputValue"
            @blur="equalizeQuantity"
            @input="sendChangeQuantityEvent($event.target.value)"
          />
          <!-- <div
            v-if="v.failedRules.between && line.product.stockLimit !== '0'"
            class="invalid-feedback"
          >
            {{ $t('basket.errors.quantityLimit', { limit: line.product.stockLimit }) }}
          </div> -->
          <span>
            ({{ getLineFinalQuantity(line) }} {{ $t("basket.unit") }},
            {{ getLinePackages(line) }} {{ $t("basket.package") }})
          </span>
        </validation-provider>
      </div>
    </td>
    <td class="col-md-1 text-right">
      {{
        currencyDisplay(line.product.price * getLineFinalQuantity(line), false)
      }}
    </td>
    <td class="text-center">
      <button class="btn btn-sm btn-danger" @click="sendRemoveEvent">
        {{ $t("buttons.delete") }}
      </button>
    </td>
  </tr>
</template>
<style scoped>
.width-mid {
  width: 100px;
}
.width-max-name {
  width: 100%;
}
</style>
<script>
import { ValidationProvider } from "vee-validate";
import Localizations from "../enums/Localizations";
import { addDays } from "date-fns";
import { currencyMixin } from "../mixins";
import i18n from "../translations";

export default {
  name: "ShoppingCartLine",
  components: { ValidationProvider },
  mixins: [currencyMixin],
  props: ["line", "indexLine"],
  data: function() {
    return {
      enableCustomPrice: false,
      priceInputValue: this.line.product.price,
      quantityInputValue: this.line.quantity,
      quantityInputEqualizerTimeout: null,
    };
  },
  computed: {
    lang() {
      return i18n.locale;
    },
    productId() {
      return this.line.product.id;
    },

    enableDiscount() {
      return !this.enableCustomPrice;
    },
  },
  watch: {
    "line.product.price": function() {
      this.priceInputValue = this.line.product.price;
    },
    quantityInputValue: function(newValue, oldValue) {
      if (this.quantityInputEqualizerTimeout) {
        clearTimeout(this.quantityInputEqualizerTimeout);
      }
      this.quantityInputEqualizerTimeout = setTimeout(
        this.equalizeQuantity,
        2000
      );
    },
  },
  methods: {
    parseDate(date) {
      return new Date(date).toISOString().substr(0, 10);
    },
    getLineLimitQuantity(line) {
      if (line.product.unitOfMeasure === "0") {
        return `numeric|required|positive|between:0,${
          line.product.stockLimit === "0" ? "10000000" : line.product.stockLimit
        }`;
      } else {
        return `numeric|required|positive|between:0,${
          line.product.stockLimit === "0" ? "10000000" : line.product.stockLimit
        }|multiply:${line.product.package}`;
      }
    },
    getLinePackages(line) {
      return Math.ceil(line.quantity / parseFloat(line.product.package || "1"));
    },
    getLineFinalQuantity(line) {
      debugger;
      if (line.product.unitOfMeasure === "0") {
        return Math.ceil(line.quantity);
      } else {
        return (
          this.getLinePackages(line) * parseFloat(line.product.package || "1")
        );
      }
    },
    sendChangePrice($event) {
      if (!isNaN($event.target.value))
        this.$emit("price", Number($event.target.value));

      this.priceInputValue = $event.target.value;
    },
    equalizeQuantity() {
      this.sendChangeQuantityEvent(this.getLineFinalQuantity(this.line));
    },
    sendChangeQuantityEvent(value) {
      if (!isNaN(value)) this.$emit("quantity", Number(value));

      this.quantityInputValue = value;
    },
    // sendChangeNameEvent($event){
    //   this.$emit("description", {
    //     value: $event.target.value,
    //     lang: this.lang
    //   });
    // },
    sendRemoveEvent() {
      this.$emit("remove", this.line);
    },
  },
};
</script>
